import { Component, Method, getAssetPath, h } from '@stencil/core';

const EXAMPLE_PHOTO = 'assets/interior-example-photo.png';

@Component({
  tag: 'image-capture-guidelines-popup',
  styleUrl: 'image-capture-guidelines-popup.css',
  assetsDirs: ['assets'],
})
export class ImageCaptureGuidelinesPopup {
  private modal: HTMLIcoModalElement;

  @Method()
  async open() {
    this.modal.open();
  }

  @Method()
  async close() {
    this.modal.close();
  }

  renderExamplePhotobox({ title = '', markIcon = '', blur = false }) {
    const imageClass = {
      'h-full w-full bg-cover': true,
      'sample-image-blur': blur,
    };
    return (
      <div class="flex w-36 flex-col text-center">
        <span>{title}</span>
        <div class="aspect-square overflow-hidden rounded-2xl border border-solid border-neutral-400">
          <div class="absolute z-10 flex w-36 justify-end rounded-2xl">
            <svg-icon icon={`image-capture-${markIcon}`} width="32" height="32" class="p-1.5" />
          </div>
          <img src={getAssetPath(EXAMPLE_PHOTO)} class={imageClass} />
        </div>
      </div>
    );
  }

  render() {
    return (
      <ico-modal ref={(el) => (this.modal = el)} id="image-capture-guidelines-modal" paddingAround borderedFooter>
        <h1 class="ico-components-heading" slot="header" data-testid="imageCaptureGuidelinesHeader">
          Photo Guidelines
        </h1>

        <div class="font-ico-body text-base max-w-3xl mb-4" slot="raw" data-testid="imageCaptureGuidelinesBody">
          <div class="mb-4">Upload only one photo per section of the vehicle (driver's side, dashboard), up to 15MB each. Acceptable file types are jpg and png.</div>
          <div class="mb-4">Make sure there's clear lighting without shadows (as much as possible).</div>
          <div class="mb-4">All photos must be your own.</div>
          <div class="mb-4">Vehicle photos only please.</div>

          <h2 class="text-ico-heading text-center text-lg mb-4">Example</h2>
          <div class="flex justify-evenly">
            {this.renderExamplePhotobox({ title: 'Good Photo', markIcon: 'checkmark' })}
            {this.renderExamplePhotobox({ title: 'Bad Photo', markIcon: 'crossmark', blur: true })}
          </div>
        </div>

        <div slot="footer" class="flex justify-end">
          <ico-button label="Done" buttonSize="large" whenClicked={() => this.close()} data-testid="imageCaptureGuidelinesDoneButton" />
        </div>
      </ico-modal>
    );
  }
}
